export default __webpack_public_path__ + "static/BETTERIRL_BLUE-33bdc28c913c6670de0f134ed4f5a0f4.png";